export const BUTTON_SELECTOR_FOCUS_TIME = 1000;

export const GUEST_SELECTOR_CONSTANTS = {
    EVENT_TYPES: {
        arrowDown: 'ArrowDown',
        tab: 'Tab'
    },
    FOCUS_TIME: 100
};
